
import { ApiProperty } from "@nestjs/swagger";
import { IsOptional, IsString, IsNumber } from "class-validator";
export class StateNameRequest {
  @ApiProperty()
  stateName: string;
}
export class StateIdRequest {
  @ApiProperty()
  stateId: number;
}
export class StateCodeRequest {
  @ApiProperty()
  stateCode: string;
  @ApiProperty()
  status: boolean;
}
